var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningValidationBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.5 5.9677 7.4196 12.833h-14.839z",
    fill: "#e8b738",
    stopColor: "#000000",
    stroke: "#e8b738",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.90132 0 0 .90004 1.2335 2.4308)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.99498,
    "aria-label": "!"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.5 17.009c-0.19209 0-0.35704-0.06681-0.49484-0.20044-0.13363-0.13363-0.20044-0.29649-0.20044-0.48858s0.06681-0.35495 0.20044-0.48858c0.1378-0.1378 0.30275-0.2067 0.49484-0.2067 0.18792 0 0.35077 0.06891 0.48858 0.2067 0.1378 0.13363 0.20671 0.29649 0.20671 0.48858s-0.06891 0.35495-0.20671 0.48858-0.30066 0.20044-0.48858 0.20044z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.026 7.985-0.11901 5.7446h-0.84562c-0.037578-4.2019-0.075169-4.3175-0.11275-5.7446z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningValidationBullet);
export default __webpack_public_path__ + "static/media/warningValidationBullet.3a81e393b1a822be8423335b97733739.svg";
export { ForwardRef as ReactComponent };